import React, { useState, useEffect } from "react";
import { db } from "../firebase-config";
import { getDocs, collection } from "firebase/firestore";
import {
  iconBehance,
  iconDribble,
  iconLinkedin,
  iconTwitter,
  iconInstagram,
  imgBehance1,
  imgBehance2,
  imgBehance3,
  imgDribbble1,
  imgDribbble2,
  imgDribbble3,
} from "../assets/index";

function Social() {
  const socialInfoCollectionRef = collection(db, "SocialInformation");
  const [userInfo, setUserInfo] = useState([]);
  useEffect(() => {
    const getUser = async () => {
      const data = await getDocs(socialInfoCollectionRef);
      setUserInfo(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };
    getUser();
  }, []);
  return (
    <>
      <div className="section">
        <h2>
          🤘 <span>Socials</span>
        </h2>
      </div>
      <div className="section" style={{ display: "none" }}>
        <div className="cont">
          <img src={iconBehance} alt="Behance" />
        </div>
        <div className="cont">
          <img src={iconDribble} alt="Dribbble" />
        </div>
        <div className="cont">
          <img src={iconLinkedin} alt="Linkedin" />
        </div>
        <div className="cont">
          <img src={iconTwitter} alt="Twitter" />
        </div>
        <div className="cont">
          <img src={iconInstagram} alt="Instagram" />
        </div>
      </div>
      {userInfo.map((user, index) => {
        return (
          <>
            <div className="section" key={user.id}>
              <div className="box1-3 box1-2">
                <div className="desc">
                  <img src={iconBehance} alt="Behance" key={index} />
                  <a href={user.Behance[(0, 2)]} target="_blank">
                    Follow
                  </a>
                </div>
                <p>{user.Behance[(0, 0)]}</p>
                <p className="link">{user.Behance[(0, 1)]}</p>
                <div className="snapGrid">
                  <img src={imgBehance1} />
                  <img src={imgBehance2} />
                  <img src={imgBehance3} />
                </div>
              </div>
              <div className="box1-3 box1-2">
                <div className="desc">
                  <img src={iconDribble} alt="Dribbble" />
                  <a href={user.Dribbble[(0, 2)]} target="_blank">
                    Follow
                  </a>
                </div>
                <p>{user.Dribbble[(0, 0)]}</p>
                <p className="link">{user.Dribbble[(0, 1)]}</p>
                <div className="snapGrid">
                  <img src={imgDribbble1} />
                  <img src={imgDribbble2} />
                  <img src={imgDribbble3} />
                </div>
              </div>
            </div>
            <div className="section">
              <div className="box1-3">
                <div className="desc">
                  <img src={iconLinkedin} alt="Linkedin" />
                  <a href={user.Linkedin[(0, 2)]} target="_blank">
                    Connect
                  </a>
                </div>
                <p>{user.Linkedin[(0, 0)]}</p>
                <p className="link">{user.Linkedin[(0, 1)]}</p>
              </div>
              <div className="box1-3">
                <div className="desc">
                  <img src={iconTwitter} alt="Twitter" />
                  <a href={user.Twitter[(0, 2)]} target="_blank">
                    Follow
                  </a>
                </div>
                <p>{user.Twitter[(0, 0)]}</p>
                <p className="link">{user.Twitter[(0, 1)]}</p>
              </div>
              <div className="box1-3">
                <div className="desc">
                  <img src={iconInstagram} alt="Instagram" />
                  <a href={user.Instagram[(0, 2)]} target="_blank">
                    Follow
                  </a>
                </div>
                <p>{user.Instagram[(0, 0)]}</p>
                <p className="link">{user.Instagram[(0, 1)]}</p>
              </div>
            </div>
          </>
        );
      })}
    </>
  );
}

export default Social;
